import React from "react";
import { fileUrl } from "../../../../../utils";

type IpropsIsvOemHeader = {
  profil: string;
  companyName: string;
  roleDiscussion: string;
};
export default function isvToOemHeaderMessage(props: IpropsIsvOemHeader) {
  return (
    <>
      <div className="d-flex mr-5">
        <div className="photo-title">
          <img src={fileUrl(props.profil)} alt="" />
        </div>
        <div className="info-title">
          <div className="company-title">
            <a href="">{props?.companyName}</a>
          </div>
          <div className="company-type">{props?.roleDiscussion}</div>
        </div>
      </div>
    </>
  );
}
